import { gql } from '@apollo/client'

const SEARCH_REFERRAL_SUB_SOURCES = gql`
  query SEARCH_REFERRAL_SUB_SOURCES($searchTerm: String, $referralSource: ID, $leadLink: ID) {
    searchReferralSubSources(searchTerm: $searchTerm, referralSource: $referralSource, leadLink: $leadLink) {
      id
      name
      order
      color
      referralSource {
        id
        name
        color
      }
    }
  }
`

export default SEARCH_REFERRAL_SUB_SOURCES
